const benicode = () => {
	const $ismembers = document.querySelectorAll('.js-ismember');
	const $benicode = document.querySelector('.js-benicode');
	if ($ismembers.length === 0 || !$benicode) {
		return;
	}

	const requiredText = 'Vul alstublieft uw benicode in.';
	function resetBenicodeInput() {
		// This will throw an error in fabricator, but that's fine, that's because fabricator doesn't validate like it does in dotnet
		$($benicode).rules('remove', 'required');
		$benicode.value = '';
		$($benicode).valid();
		$benicode.parentElement.style.display = 'none';
		$benicode.parentElement.parentElement.parentElement.querySelector('.tooltip-icon').style.display = 'none';
	}
	function setBenicodeInput() {
		$benicode.parentElement.style.display = '';
		$benicode.parentElement.parentElement.parentElement.querySelector('.tooltip-icon').style.display = '';
		$($benicode).rules('add', {
			required: true,
			messages: {
				required: requiredText
			}
		});
	}
	for (let i = 0; i < $ismembers.length; i += 1) {
		const $ismember = $ismembers[i];
		$ismember.addEventListener('change', () => {
			const ismember = $ismember.value;
			if (ismember === 'on') {
				setBenicodeInput();
			} else {
				resetBenicodeInput();
			}
		});
	}

	resetBenicodeInput();
};

export default benicode;
